import { render, staticRenderFns } from "./DownloadDentalFile.vue?vue&type=template&id=b043dda2&"
import script from "./DownloadDentalFile.vue?vue&type=script&lang=js&"
export * from "./DownloadDentalFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports